<template>
  <div name="vue-validate">
    <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
      <input type="text" v-validate="'required|email'" name="email" :class="{ 'input-error' : errors.has('form-1.email') }" />
      <div class="text-error" v-show="errors.has('form-1.email')">{{ errors.first('form-1.email') }}</div>
      <button class="button is-primary" type="submit" name="button">Submit Form 1</button>
    </form>
    <form @submit.prevent="validateForm('form-2')" data-vv-scope="form-2">
      <input type="text" v-validate="'required|date_format:DD/MM/YYYY'" name="date" :class="{ 'input-error' : errors.has('form-2.date') }" />
      <div class="text-error" v-show="errors.has('form-2.date')">{{ errors.first('form-2.date') }}</div>
      <button class="button is-primary" type="submit" name="button">Submit Form 2</button>
    </form>
    <form @submit.prevent="validateForm('form-3')" data-vv-scope="form-3">
      <custom-input v-validate="'required|date_format:DD/MM/YYYY'" data-vv-value-path="innerValue" data-vv-name="form-3.custom" :has-error="errors.has('form-3.custom')" />
      <div class="text-error" v-show="errors.has('form-3.custom')">{{ errors.first('form-3.custom') }}</div>
      <button class="button is-primary" type="submit" name="button">Submit Form 3</button>
    </form>
    <div>
      <custom-input v-validate="'required|date_format:DD/MM/YYYY'" data-vv-value-path="innerValue" data-vv-name="custom" label="Email" :has-error="errors.has('custom')">
      </custom-input>
      <span v-show="errors.has('custom')" class="help is-danger">{{ errors.first('custom') }}</span>
      <button @click="validate" type="button" class="button is-primary">Validate All</button>
    </div>
    <div>
      <hrms-timepicker  v-model="time1"
                        v-validate="'required|date_format:HH:mm'"
                        data-vv-name="time1"
                        data-vv-value-path="inputTime"
                        :class="{ 'input-error' : errors.has('time1') }"
                        :has-error="errors.has('time1')" />
      <div class="text-error" v-show="errors.has('time1')">{{ errors.first('time1') }}</div>
    </div>
    <!-- <form @submit.prevent="validateForm('form-4')" data-vv-scope="form-4"> -->
      <input type="text" v-validate="'date_format:DD/MM/YYYY'" v-model="date1" name="date1" :class="{ 'input-error' : errors.has('date1') }" />
      <div class="text-error" v-show="errors.has('date1')">{{ errors.first('date1') }}</div>
      <input type="text" v-validate="'date_format:DD/MM/YYYY|after:date1'" v-model="date2" name="date2" :class="{ 'input-error' : errors.has('date2') }" />
      <div class="text-error" v-show="errors.has('date2')">{{ errors.first('date2') }}</div>
      <button class="button is-primary" type="submit" name="button">Submit Form 4</button>
    <!-- </form> -->
    <div>
      <input type="text" v-validate="'requiredWhenExist:datee2|date_format:DD/MM/YYYY'" name="datee1" v-model="datee1" :class="{ 'input-error' : errors.has('datee1') }" />
      <div class="text-error" v-show="errors.has('datee1')">{{ errors.first('datee1') }}</div>
      <input type="text" v-validate="'requiredWhenExist:datee1|date_format:DD/MM/YYYY'" name="datee2" v-model="datee2" :class="{ 'input-error' : errors.has('datee2') }" />
      <div class="text-error" v-show="errors.has('datee2')">{{ errors.first('datee2') }}</div>
    </div>
    <div>
      <input type="text" v-model="dtereq"
             maxlength="10" 
             v-validate="'required|date_format:DD/MM/YYYY'" 
             name="dtereq" 
             placeholder="DD/MM/YYYY" 
             :class="{ 'input-error' : errors.has('dtereq') }" />
      <div v-show="errors.has('dtereq')" class="text-error">{{ errors.first('dtereq') }}</div>
      <button @click="validateFields()">Save</button>
    </div>
  </div>
</template>

<script>
import customInput from './customInput'

export default {
  name: 'vue-validate',
  data () {
    return {
      dtereq: '',
      time1: '',
      time2: '',
      date1: '',
      date2: '',
      datee1: '',
      datee2: ''
    }
  },
  watch: {
    datee1 () {
      this.$validator.validate('datee2', this.datee2).catch(e => {})
    },
    datee2 () {
      this.$validator.validate('datee1', this.datee1).catch(e => {})
    }
  },
  methods: {
    validateFields () {
      this.$validator.validateAll()
        .then(result => {
          if (result) {
            console.log('validate pass')
          }
        })
    },
    validateForm (scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          console.log('Form submit!!')
        }
      })
    },
    validate () {
      this.$validator.validateAll().then(result => {
        // eslint-disable-next-line
        console.log(`Validation Result: ${result}`)
      })
    }
  },
  components: {
    customInput
  }
}
</script>


// WEBPACK FOOTER //
// component.vue?7faa9cf7